import { Link, useLocation } from "react-router-dom";
import { PORTALS } from "../../../utils/portalTypes";
import clinic from "../clinic.module.css";
import landing from "../Auth/auth.module.css";
import L from "../../../constants/baysportLabels";

const ITEMS = [
  { portal: PORTALS.patient, label: L.clients },
  { portal: PORTALS.staff, label: L.trainers },
  { portal: PORTALS.admin, label: "Админ" },
];

export default function PortalSwitcher({ variant = "clinic" }) {
  const s = variant === "landing" ? landing : clinic;
  const { pathname } = useLocation();
  const active = (() => {
    if (pathname.startsWith("/staff")) return "staff";
    if (pathname.startsWith("/manage")) return "admin";
    return "patient";
  })();

  return (
    <nav className={s.portalSwitcher} aria-label="Разделы клуба">
      {ITEMS.map(({ portal, label }) => (
        <Link
          key={portal.id}
          to={portal.home}
          className={
            active === portal.id
              ? `${s.portalSwitcherLink} ${s.portalSwitcherLinkActive}`
              : s.portalSwitcherLink
          }
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}
